import { render, staticRenderFns } from "./CandidateWizardDashboard.vue?vue&type=template&id=c378fbe0&"
import script from "./CandidateWizardDashboard.vue?vue&type=script&lang=js&"
export * from "./CandidateWizardDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports